export enum TagTypesKey {
  SHIPPING = 'SHIPPING',
  GOOGLE_ACCOUNT = 'GOOGLE_ACCOUNT',
  EMAIL = 'EMAIL',
}
